export default __webpack_public_path__ + "25cde73413ad544a885ab2bb6c3fcb1b.svg";